exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs[data-v-3fa8ec66]{text-align:left;padding:20px;display:flex;align-items:center;border-bottom:1px solid #e3e3e3;color:#9f9999}.tabs .tab[data-v-3fa8ec66]{margin-left:10px;display:flex;cursor:pointer}.tabs .tab img[data-v-3fa8ec66]{margin-right:10px}.tabs .active[data-v-3fa8ec66]{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fa8ec66","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/basic/FwTab.vue
// module id = 926
// module chunks = 0